import { createReducer, on } from "@ngrx/store";
import { ImportBatchDisableDeleteState, initialImportBatchDisableDeleteState } from "./import-batch-disable-delete.state";
import { UploadBatchDisableDeleteCSV, UploadBatchDisableDeleteCSVSuccess, UploadBatchDisableDeleteCSVError, GetBatchDisableDeleteImportStatusSuccess, GetBatchDisableDeleteImportStatusError, AuthorizeImportBatchDisableDeleteSSE, AuthorizeImportBatchDisableDeleteSSESuccess, AuthorizeImportBatchDisableDeleteSSEError, HasImportedBatchDisableDelete, HasImportedBatchDisableDeleteSuccess, HasImportedBatchDisableDeleteError, DownloadBatchDisableDeleteImportErrorList, DownloadBatchDisableDeleteImportErrorListSuccess, DownloadBatchDisableDeleteImportErrorListError, CancelBatchDisableDeleteImport, CancelBatchDisableDeleteImportSuccess, CancelBatchDisableDeleteImportError, ClearBatchDisableDeleteImportSession, ClearBatchDisableDeleteImportSessionResult, ResetBatchDisableDeleteImportState } from "./import-batch-disable-delete.action";

export const ImportBatchDisableDeleteReducers = createReducer(
  initialImportBatchDisableDeleteState,
  on(UploadBatchDisableDeleteCSV, (state): ImportBatchDisableDeleteState => {
    return {
      ...state,
      uploadLoader: true,
      uploadResult: null,
      uploadError: null,
    }
  }),
  on(UploadBatchDisableDeleteCSVSuccess, (state, action): ImportBatchDisableDeleteState => {
    return {
      ...state,
      uploadLoader: false,
      uploadResult: action.result,
    };
  }),
  on(UploadBatchDisableDeleteCSVError, (state, action): ImportBatchDisableDeleteState => {
    return {
      ...state,
      uploadLoader: false,
      uploadError: action.error,
    };
  }),
  on(GetBatchDisableDeleteImportStatusSuccess, (state, action): ImportBatchDisableDeleteState => {
    return {
      ...state,
      statusLoader: false,
      statusResult: action.result,
    };
  }),
  on(GetBatchDisableDeleteImportStatusError, (state, action): ImportBatchDisableDeleteState => {
    return {
      ...state,
      statusLoader: false,
      statusError: action.error,
    };
  }),
  on(AuthorizeImportBatchDisableDeleteSSE, (state): ImportBatchDisableDeleteState => {
    return {
      ...state,
      authSSELoader: true,
      authSSEResult: false,
      authSSEError: null,
    };
  }),
  on(AuthorizeImportBatchDisableDeleteSSESuccess, (state, action): ImportBatchDisableDeleteState => {
    return {
      ...state,
      authSSELoader: false,
      authSSEResult: action.result,
    };
  }),
  on(AuthorizeImportBatchDisableDeleteSSEError, (state, action): ImportBatchDisableDeleteState => {
    return {
      ...state,
      authSSELoader: false,
      authSSEError: action.error,
    };
  }),
  on(HasImportedBatchDisableDelete, (state): ImportBatchDisableDeleteState => {
    return {
      ...state,
      hasImportLoader: true,
      hasImportResult: 0,
      hasImportError: null,
    };
  }),
  on(HasImportedBatchDisableDeleteSuccess, (state, action): ImportBatchDisableDeleteState => {
    return {
      ...state,
      hasImportLoader: false,
      hasImportResult: action.result,
    };
  }),
  on(HasImportedBatchDisableDeleteError, (state, action): ImportBatchDisableDeleteState => {
    return {
      ...state,
      hasImportLoader: false,
      hasImportError: action.error,
    };
  }),
  on(DownloadBatchDisableDeleteImportErrorList, (state): ImportBatchDisableDeleteState => {
    return {
      ...state,
      errorListFile: null,
      errorListLoader: true,
      errorListError: null,
    };
  }),
  on(DownloadBatchDisableDeleteImportErrorListSuccess, (state, action): ImportBatchDisableDeleteState => {
    return {
      ...state,
      errorListFile: action.result,
      errorListLoader: false,
    };
  }),
  on(DownloadBatchDisableDeleteImportErrorListError, (state, action): ImportBatchDisableDeleteState => {
    return {
      ...state,
      errorListLoader: false,
      errorListError: action.error,
    };
  }),
  on(CancelBatchDisableDeleteImport, (state): ImportBatchDisableDeleteState => {
    return {
      ...state,
      cancelImportLoader: true,
      cancelImportResult: null,
    };
  }),
  on(CancelBatchDisableDeleteImportSuccess, (state): ImportBatchDisableDeleteState => {
    return {
      ...state,
      cancelImportLoader: false,
      cancelImportResult: true,
    };
  }),
  on(CancelBatchDisableDeleteImportError, (state): ImportBatchDisableDeleteState => {
    return {
      ...state,
      cancelImportLoader: false,
      cancelImportResult: false,
    };
  }),
  on(ClearBatchDisableDeleteImportSession, (state): ImportBatchDisableDeleteState => {
    return {
      ...state,
      clearSessionLoader: true,
    };
  }),
  on(ClearBatchDisableDeleteImportSessionResult, (state): ImportBatchDisableDeleteState => {
    return {
      ...state,
      clearSessionLoader: true,
    };
  }),
  on(ResetBatchDisableDeleteImportState, (): ImportBatchDisableDeleteState => {
    return initialImportBatchDisableDeleteState;
  }),
);